const GstWarning = () => (
    <div className="gst-warning">
        GST applicable by category, standard 18%
    </div>
);

export default GstWarning;